<template>
  <div v-if="visibleUrls.length" class="psi">
    <div class="psi-frame">
      <img :key="currentUrl" :src="currentUrl" :alt="alt" class="psi-image" @error="hide(currentUrl)" />
      <template v-if="hasSeveral">
        <button type="button" class="psi-arrow psi-arrow-prev" :aria-label="copy.previous" @click="move(PREVIOUS)">&#8249;</button>
        <button type="button" class="psi-arrow psi-arrow-next" :aria-label="copy.next" @click="move(NEXT)">&#8250;</button>
      </template>
    </div>
    <div v-if="hasSeveral" class="psi-dots">
      <button
        v-for="(url, index) in visibleUrls"
        :key="url"
        type="button"
        class="psi-dot"
        :class="{ 'psi-dot-active': index === position }"
        :aria-label="`${copy.image} ${index + NEXT}`"
        @click="position = index"
      ></button>
    </div>
  </div>
</template>

<script>
const COPY = { previous: 'Imagen anterior', next: 'Imagen siguiente', image: 'Imagen' };
const FIRST_POSITION = 0;
const PREVIOUS = -1;
const NEXT = 1;
const SINGLE = 1;

export default {
  name: 'PortalUpdateStepImages',
  props: {
    urls: { type: Array, default: () => [] },
    alt: { type: String, default: '' },
  },
  data() {
    return { position: FIRST_POSITION, broken: [], copy: COPY, PREVIOUS, NEXT };
  },
  computed: {
    visibleUrls() {
      return this.urls.filter((url) => !this.broken.includes(url));
    },
    hasSeveral() {
      return this.visibleUrls.length > SINGLE;
    },
    currentUrl() {
      return this.visibleUrls[Math.min(this.position, this.visibleUrls.length - NEXT)];
    },
  },
  watch: {
    urls() {
      this.position = FIRST_POSITION;
      this.broken = [];
    },
  },
  methods: {
    move(direction) {
      const total = this.visibleUrls.length;
      this.position = (this.position + direction + total) % total;
    },
    hide(url) {
      this.broken.push(url);
    },
  },
};
</script>

<style scoped>
.psi { margin-top: 8px; }
.psi-frame { position: relative; }
.psi-image { display: block; max-width: 100%; border-radius: 8px; border: 1px solid #e3e3e5; margin: 0 auto; }
.psi-arrow { position: absolute; top: 50%; transform: translateY(-50%); width: 32px; height: 32px; border-radius: 50%; border: none; background: rgba(0, 0, 0, 0.45); color: #fff; font-size: 22px; line-height: 1; cursor: pointer; }
.psi-arrow-prev { left: 8px; }
.psi-arrow-next { right: 8px; }
.psi-dots { display: flex; justify-content: center; gap: 6px; margin-top: 8px; }
.psi-dot { width: 8px; height: 8px; border-radius: 50%; border: none; padding: 0; background: #d0d0d3; cursor: pointer; }
.psi-dot-active { background: #01662E; }
</style>
